/**
 * Hook de datos de las **alertas de salto no vistas**
 * (`GET /api/v1/talonarios/alertas`).
 *
 * Datos de servidor -> TanStack Query. La query key incluye la sede activa. El
 * endpoint es de permiso SILENCIOSO (sin `manage_talonarios` devuelve vacío, no
 * 403), así que el panel del supervisor puede montarlo sin reventar. Pensado para
 * refresco periódico (polling) además de la carga inicial.
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchTalonarioAlertas } from "../api";
import type { TalonarioAlertasResponse } from "../types";
import { talonarioAlertasQueryKey } from "./queryKeys";

/** Intervalo de refresco de las alertas (polling), en ms. */
const ALERTAS_REFETCH_INTERVAL = 30_000;

export function useTalonarioAlertas() {
  const sedeId = getActiveSedeId();
  return useQuery<TalonarioAlertasResponse>({
    queryKey: talonarioAlertasQueryKey(sedeId),
    queryFn: fetchTalonarioAlertas,
    refetchInterval: ALERTAS_REFETCH_INTERVAL,
    staleTime: 10_000,
  });
}
